<div class="dialog-backdrop" *ngIf="visible" (click)="onBackdropClick()">
	<div class="force-assign-container" (click)="$event.stopPropagation()">
		<mat-stepper #stepper [linear]="false" [animationDuration]="'300'">
			<mat-step>
				<div class="dialog-header">
					<h3 class="dialog-title">Force Assign Request</h3>
					<p class="dialog-subtitle">Nearby Driver/s</p>
				</div>

				<div *ngIf="loading" class="loading-state">
					<mat-spinner diameter="48"></mat-spinner>
					<p class="loading-text">Loading nearby drivers...</p>
				</div>

				<div *ngIf="!loading && (!drivers || drivers.length === 0)" class="empty-state">
					<mat-icon class="empty-icon">groups</mat-icon>
					<p class="empty-title">No Drivers Available</p>
					<p class="empty-subtitle">There are no nearby drivers available at the moment.</p>
					<button mat-stroked-button class="close-btn" (click)="close()">
						Close
					</button>
				</div>

				<div *ngIf="!loading && drivers && drivers.length > 0" class="drivers-list">
					<div *ngFor="let driver of drivers" class="driver-item">
						<div class="driver-info">
							<img [src]="getDriverImageUrl(driver)"
								 [alt]="getDriverFullName(driver)"
								 class="driver-avatar"
								 (error)="onDriverImageError($event)">
							<div class="driver-details">
								<span class="driver-name">{{ getDriverFullName(driver) }}</span>
								<div *ngIf="shouldShowWarning(driver)" class="driver-warning">
									<mat-icon class="warning-icon">warning_amber</mat-icon>
									<span>{{ driver.WarningMessage }}</span>
								</div>
								<div *ngIf="shouldShowDistance(driver)" class="driver-distance">
									<mat-icon class="distance-icon">place</mat-icon>
									<span>{{ driver.DistanceInKm | number:'1.2-2' }} km</span>
								</div>
							</div>
						</div>
						<button mat-raised-button color="primary" class="assign-btn" (click)="selectDriver(driver)">
							Assign
						</button>
					</div>
				</div>
			</mat-step>

			<mat-step>
				<div class="confirmation-content">
					<div *ngIf="assignLoading" class="assign-loading-state">
						<mat-spinner diameter="48"></mat-spinner>
						<p class="assign-loading-text">Assigning driver...</p>
					</div>

					<div *ngIf="assignError && !assignLoading" class="assign-error-state">
						<mat-icon class="error-icon">error_outline</mat-icon>
						<p class="error-title">Assignment Failed</p>
						<p class="error-message">{{ errorMessage }}</p>
						<div class="error-actions">
							<button mat-stroked-button class="discard-btn" (click)="discardConfirmation()">
								Cancel
							</button>
							<button mat-raised-button color="primary" class="retry-btn" (click)="retryAssign()">
								Retry
							</button>
						</div>
					</div>

					<div *ngIf="!assignLoading && !assignError">
						<h3 class="confirmation-title">Force Assign?</h3>
						<p class="confirmation-description">
							Are you sure you want to force assign this request? This will override the
							system and assign the trip directly to this driver
						</p>
						<p class="confirmation-label">The assign Driver for this Request</p>

						<div *ngIf="selectedDriver" class="selected-driver">
							<img [src]="getDriverImageUrl(selectedDriver)"
								 [alt]="getDriverFullName(selectedDriver)"
								 class="selected-driver-avatar"
								 (error)="onDriverImageError($event)">
							<div class="selected-driver-info">
								<span class="selected-driver-name">{{ getDriverFullName(selectedDriver) }}</span>
								<span *ngIf="shouldShowWarning(selectedDriver)" class="selected-driver-warning">{{ selectedDriver.WarningMessage }}</span>
								<span *ngIf="shouldShowDistance(selectedDriver)" class="selected-driver-badge">{{ selectedDriver.DistanceInKm | number:'1.2-2' }} km</span>
							</div>
						</div>

						<div class="confirmation-actions">
							<button mat-stroked-button
									class="discard-btn"
									[class.highlight-shake]="highlightDiscard"
									(click)="discardConfirmation()">
								Discard
							</button>
							<button mat-raised-button color="primary" class="confirm-btn" (click)="confirmAssign()">
								Yes, assign this ride
							</button>
						</div>
					</div>
				</div>
			</mat-step>
		</mat-stepper>
	</div>
</div>
